export default Object.freeze({
  FLEXILIMITS_SUBLIMITS_INFORMATION: 'Refer to product guide below for further detail.',
});
